import {
  differenceInCalendarDays,
  differenceInCalendarWeeks,
  isThisWeek,
  isToday,
  isYesterday,
} from 'date-fns';

import { GroupTypes } from '../../history-group/HistoryGroup';
import { Conversation } from '../../use-chat/use-chat.types';

const mapKeyToConfig: Record<
  Exclude<GroupTypes, 'starred'>,
  (earlierDate: Date, todayDate: Date) => boolean
> = {
  today: earlierDate => isToday(earlierDate),
  yesterday: earlierDate => isYesterday(earlierDate),
  twoDaysAgo: (earlierDate, todayDate) =>
    differenceInCalendarDays(todayDate, earlierDate) === 2,
  thisWeek: earlierDate => isThisWeek(earlierDate),
  older: (earlierDate, todayDate) =>
    differenceInCalendarWeeks(todayDate, earlierDate) >= 1,
};

export const groupConversations = (conversations: Conversation[]) => {
  const keys = Object.keys(mapKeyToConfig) as (keyof typeof mapKeyToConfig)[];
  const today = new Date();

  return conversations.reduce(
    (res, c) => {
      const key = keys.find(key =>
        mapKeyToConfig[key](new Date(c.date), today)
      );

      if (key) {
        res[key] = res[key] ? [...res[key], c] : [c];
      }

      return res;
    },
    {} as Record<Exclude<GroupTypes, 'starred'>, Conversation[]>
  );
};
